import { render } from "./SlHeader.vue?vue&type=template&id=5c50c550&scoped=true"
import script from "./SlHeader.vue?vue&type=script&lang=js"
export * from "./SlHeader.vue?vue&type=script&lang=js"

import "./SlHeader.vue?vue&type=style&index=0&id=5c50c550&lang=scss&scoped=true"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c50c550"]])

export default __exports__